module.exports = __webpack_public_path__ + "img/fei.0c60ed88.jpg";